import {Route} from '../../hooks/use-navigation';

export const routesToDisplayName = {
	[Route.List]: 'All Assignments',
	[Route.ListInProgress]: 'In Progress Assignments',
	[Route.ListNotStarted]: 'Not Started Assignments',
	[Route.ListCompleted]: 'Completed Assignments',
	[Route.ListDraft]: 'Draft Assignments',
};
